import React, { ReactNode } from 'react'
import { makeStyles } from '@mui/styles'
import MaterialUITooltip, { TooltipProps as MaterialUITooltipProps } from '@mui/material/Tooltip'

import { color } from 'styles/colors'

interface TooltipProps {
  className?: string
  title: ReactNode | string
  disableFocusListener?: boolean
  showArrow?: boolean
  placement?: MaterialUITooltipProps['placement']
  children: MaterialUITooltipProps['children']
}

const BUBBLE_RADIUS = 16
const ARROW_RADIUS = 6

const Tooltip = ({ className, title, placement, disableFocusListener, children, showArrow }: TooltipProps) => {
  const classes = makeStyles(() => (S))()

  return (
    <MaterialUITooltip
      className={className}
      disableFocusListener={disableFocusListener}
      disableInteractive
      {...{ placement, title }}
      enterDelay={500}
      leaveDelay={50}
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      arrow={showArrow}
      slotProps={{
        popper: {
          popperOptions: {
            modifiers: [
              { name: 'flip', enabled: true },
              { name: 'preventOverflow', enabled: true }
            ]
          }
        }
      }}
    >
      {children}
    </MaterialUITooltip>
  )
}

export default Tooltip

const S = {
  tooltip: {
    fontSize: '14px',
    fontWeight: 'normal',
    maxWidth: '340px',
    padding: '16px 24px',
    color: color('tooltipText'),
    backgroundColor: color('paneBackground'),
    border: `1px solid ${color('tooltipBorder')}`,
    borderRadius: `${BUBBLE_RADIUS}px`,
    boxShadow: `0px 8px 16px 0px ${color('tooltipShadow')}`
  },
  arrow: {
    fontSize: '25px',
    color: color('paneBackground'),
    // thin border on the arrow's visible edges to match the body
    '&:before': {
      border: `1px solid ${color('tooltipBorder')}`,
      boxSizing: 'border-box'
    },
    // round only the protruding tip corner of the rotated square arrow
    '[data-popper-placement*="bottom"] &&&:before': {
      borderTopLeftRadius: `${ARROW_RADIUS}px`
    },
    '[data-popper-placement*="top"] &&&:before': {
      borderBottomRightRadius: `${ARROW_RADIUS}px`
    },
    '[data-popper-placement*="left"] &&&:before': {
      borderTopRightRadius: `${ARROW_RADIUS}px`
    },
    '[data-popper-placement*="right"] &&&:before': {
      borderBottomLeftRadius: `${ARROW_RADIUS}px`
    }
  }
}
